import { Fragment } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { styled } from '@mui/material/styles';
import { Typography } from '@components/Typography';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useTranslation } from '@hooks';

const StyledRadioGroup = styled(RadioGroup)({
    '& .MuiFormControlLabel-root': {
        marginRight: 0,
        marginLeft: '-3px !important',
    },
    '@media (max-width: 600px)': {
        gridColumn: '1 / span 2',
    },
});

export const FrequencyMap = {
    Once: 0,
    EveryTime: 1,
};

const Frequency = ({ isView }) => {
    const { t } = useTranslation();
    const { control, setValue } = useFormContext();

    return (
        <>
            <Controller
                control={control}
                name="onePerContact"
                render={({ field }) => (
                    <>
                        {[
                            { id: `${FrequencyMap.EveryTime}`, name: t('CampaignsPage.triggerEveryTime') },
                            { id: `${FrequencyMap.Once}`, name: t('CampaignsPage.triggerOnce') },
                        ].map(type => (
                            <Fragment key={type.id}>
                                <StyledRadioGroup
                                    value={field.value}
                                    onChange={e =>
                                        setValue('onePerContact', e.target.value, {
                                            shouldDirty: true,
                                            shouldValidate: true,
                                        })
                                    }
                                >
                                    <FormControlLabel
                                        value={`${type.id}`}
                                        control={
                                            <Radio
                                                sx={{
                                                    color: 'rgba(0, 0, 0, 0.6)',
                                                    padding: '6px',
                                                    '&.Mui-checked': { color: '#1F4C5C' },
                                                }}
                                                disabled={isView}
                                            />
                                        }
                                        label={
                                            <Typography variant="body2" sx={{ marginLeft: '8px' }}>
                                                {type.name}
                                            </Typography>
                                        }
                                        disabled={isView}
                                    ></FormControlLabel>
                                </StyledRadioGroup>
                            </Fragment>
                        ))}
                    </>
                )}
            />
        </>
    );
};

export default Frequency;
